import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_c('a-card', {
    attrs: {
      "title": _vm.cardTitle,
      "size": "small",
      "bordered": false
    }
  }, [_c('template', {
    slot: "extra"
  }, [_c('a-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm.$route.query.type != 3 ? _c('a-button', {
    style: {
      marginLeft: '8px'
    },
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "click": function click($event) {
        return _vm.saveDraft();
      }
    }
  }, [_vm._v(" 保存 ")]) : _vm._e(), _vm.$route.query.type != 3 ? _c('a-button', {
    style: {
      marginLeft: '8px'
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.submitReimburse
    }
  }, [_vm._v(" 提交 ")]) : _vm._e()], 1), _c('a-form-model', {
    ref: "addForm",
    staticClass: "form-content",
    attrs: {
      "model": _vm.formObject.detail,
      "rules": _vm.rules,
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol
    }
  }, [_c('a-row', [_c('div', {
    staticClass: "expense-title"
  }, [_c('strong', [_vm._v("费用报销单")])])]), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "所属组织及岗位",
      "prop": "organPostId",
      "rules": {
        type: 'array',
        required: _vm.organPostId.length === 0,
        message: '请选择所属组织及岗位',
        trigger: 'change'
      }
    }
  }, [_c('a-cascader', {
    style: {
      width: '100%'
    },
    attrs: {
      "options": _vm.options,
      "show-search": {
        filterOption: _vm.filterOption
      },
      "placeholder": "请选择所属组织及岗位",
      "getPopupContainer": function getPopupContainer(triggerNode) {
        return triggerNode.parentNode;
      }
    },
    on: {
      "change": _vm.onOrganAndJob
    },
    model: {
      value: _vm.organPostId,
      callback: function callback($$v) {
        _vm.organPostId = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "organPostId"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "报销日期",
      "prop": "applyDate"
    }
  }, [_c('a-date-picker', {
    style: {
      width: '100%'
    },
    model: {
      value: _vm.formObject.detail.applyDate,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject.detail, "applyDate", $$v);
      },
      expression: "formObject.detail.applyDate"
    }
  })], 1)], 1), _c('a-col', {
    staticClass: "disabled-cursor",
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    staticClass: "disabled-events",
    attrs: {
      "label": "经办人",
      "prop": "operator"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入经办人",
      "max-length": 51
    },
    model: {
      value: _vm.formObject.detail.operator,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject.detail, "operator", $$v);
      },
      expression: "formObject.detail.operator"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a-form-model-item', {
    staticStyle: {
      "margin-left": "3%"
    },
    attrs: {
      "label": "报销事项",
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 22
      },
      "prop": "reason"
    }
  }, [_c('a-textarea', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入报销事项",
      "max-length": 201,
      "rows": 2
    },
    model: {
      value: _vm.formObject.detail.reason,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject.detail, "reason", $$v);
      },
      expression: "formObject.detail.reason"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a-form-model-item', {
    staticStyle: {
      "margin-left": "3%"
    },
    attrs: {
      "label": "经办人账号",
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 22
      },
      "prop": "accountNumber"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入经办人账号",
      "max-length": 20
    },
    model: {
      value: _vm.formObject.detail.accountNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject.detail, "accountNumber", $$v);
      },
      expression: "formObject.detail.accountNumber"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a-form-model-item', {
    staticStyle: {
      "margin-left": "3%"
    },
    attrs: {
      "label": "开户行",
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 22
      },
      "prop": "accountOpening"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入开户行",
      "max-length": 51
    },
    model: {
      value: _vm.formObject.detail.accountOpening,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject.detail, "accountOpening", $$v);
      },
      expression: "formObject.detail.accountOpening"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    staticStyle: {
      "margin-left": "-3.5%"
    },
    attrs: {
      "label": "金额(小写)",
      "prop": "totalAmount",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c('a-input-number', {
    style: {
      width: '100%'
    },
    attrs: {
      "min": 1,
      "max": 999999999,
      "precision": 2,
      "placeholder": "请输入金额(小写)"
    },
    on: {
      "change": _vm.inputAmount
    },
    model: {
      value: _vm.formObject.detail.totalAmount,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject.detail, "totalAmount", $$v);
      },
      expression: "formObject.detail.totalAmount"
    }
  })], 1)], 1), _c('a-col', {
    staticClass: "disabled-cursor",
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    staticClass: "disabled-events",
    attrs: {
      "label": "金额(大写)",
      "prop": "totalAmountBig",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "根据输入金额自动转换",
      "max-length": 20
    },
    model: {
      value: _vm.formObject.detail.totalAmountBig,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject.detail, "totalAmountBig", $$v);
      },
      expression: "formObject.detail.totalAmountBig"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a-form-model-item', {
    staticStyle: {
      "margin-left": "3%"
    },
    attrs: {
      "label": "备注",
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 22
      },
      "prop": "remarks"
    }
  }, [_c('a-textarea', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入备注",
      "max-length": 501,
      "rows": 3
    },
    model: {
      value: _vm.formObject.detail.remarks,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject.detail, "remarks", $$v);
      },
      expression: "formObject.detail.remarks"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a-form-model-item', {
    staticStyle: {
      "margin-left": "3%"
    },
    attrs: {
      "label": "附件",
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 22
      }
    }
  }, [_c('a-upload-dragger', {
    staticClass: "common-upload",
    attrs: {
      "name": "file",
      "accept": ".pdf,.doc,.docx,.jpg,.jpge,",
      "multiple": true,
      "customRequest": _vm.actionUpload,
      "before-upload": _vm.beforeUpload,
      "fileList": _vm.fileObj,
      "disabled": _vm.$route.query.type === 3,
      "remove": _vm.delFile
    },
    model: {
      value: _vm.fileObj,
      callback: function callback($$v) {
        _vm.fileObj = $$v;
      },
      expression: "fileObj"
    }
  }, [_c('p', {
    staticClass: "ant-upload-drag-icon"
  }, [_c('a-icon', {
    attrs: {
      "type": "inbox"
    }
  })], 1), _c('p', {
    staticClass: "ant-upload-text"
  }, [_vm._v("单击此区域选择文件上传")]), _c('p', {
    staticClass: "ant-upload-hint"
  }, [_vm._v(" 允许多个上传。(支持doc、docx、jpge、jpg、pdf格式上传，最大上传500MB) ")])])], 1)], 1)], 1)], 1)], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };